export default "__VITE_ASSET__BBU$t3Dc__"